let utils = {
  /**
   * 判断是否支持sessionStorage和localStorage
   * @return {Boolean} true/false
   *
   */
  isSupportStorage: function () {
    if (window.sessionStorage && window.localStorage)
      return true;
    else
      return false;
  },
  /**
   * 判断是否为object对象，排除null
   * @param  {obj}  value 判断的对像
   * @return {Boolean} true/false
   *
   */
  isObject: function (value) {
    return (value !== null && typeof value === 'object');
  },

  /**
   * 判断字符串是否为JSON
   * @param  {String}  str json字符串
   * @return {Boolean}     true/false
   */
  isJSON: function (str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  },

  /**
   * 保存数据在sessionStorage，以键值对存在
   * @param {String} name  键名
   * @param {String/Object/Array/...} value 键值
   *
   */
  setSessionStorage: function (name, value) {
    if (!this.isSupportStorage())
      return null;

    if (this.isObject(value))
      value = JSON.stringify(value);

    sessionStorage.setItem(name, value);
  },

  /**
   * 获取sessionStorage数据
   * @param {String} name 键名
   * @return {String/Object/...} 键值
   *
   */
  getSessionStorage: function (name) {
    if (!this.isSupportStorage())
      return null;
    let value = sessionStorage.getItem(name);
    if (this.isJSON(value)) {
      return JSON.parse(value);
    } else {
      return value;
    }
  },

  /**
   * 保存数据在localStorage，以键值对存在
   * @param {String} name  键名
   * @param {String/Object/Array/...} value 键值
   *
   */
  setLocalStorage: function (name, value) {
    if (!this.isSupportStorage())
      return null;

    if (this.isObject(value))
      value = JSON.stringify(value);

    localStorage.setItem(name, value);
  },
  //去除对象中属性值为null的字段
  removePropertyOfNull:function (obj) {
    Object.keys(obj).forEach(item => {
      if (!obj[item]) delete obj[item]
    })
    return obj;
  },
  //页面按钮权限处理
  regroupAuthor: function (oldVal, newVal) {
    oldVal.forEach(item => {
      newVal.forEach(valItem => {
        if (item.name == valItem.name) {
          item.operation = valItem.operation
          if (item.child && valItem.child) {
            utils.regroupAuthor(item.child, valItem.child)
          }
        }
      })
    })
    return oldVal
  },
}
export default utils



// WEBPACK FOOTER //
// ./src/utils/utils.js